import * as yup from 'yup'

export const pricerFormValidationSchema = yup.object().shape({
    pricingGoal: yup.string().required(),
})
